import { useGetApplicant } from '@/lib/api'
import { useGetApplicationsByApplicantId } from '@/lib/api/applicant.hook'
import { useMe } from '@/useMe'
import { FC, PropsWithChildren, useEffect, useMemo, useReducer } from 'react'
import { useSessionStorage } from 'usehooks-ts'
import { ApplicationContext, applicationStateReducer, initialState } from './ApplicationContext'

export const ApplicationContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(applicationStateReducer, initialState)
  const [isLoggedIn, setIsLoggedIn] = useSessionStorage('isLoggedIn', false)

  const { data: loggedInUser, isError } = useMe({
    retry: false,
    enabled: isLoggedIn,
  })
  const { data: applicant } = useGetApplicant(loggedInUser?.id ?? '')
  const { data: applications } = useGetApplicationsByApplicantId(loggedInUser?.id ?? '')

  useEffect(() => {
    if (applications && applications.length) {
      dispatch({ action: 'SET_APPLICATIONS', payload: applications })
    }
  }, [applications])

  useEffect(() => {
    if (applicant) {
      dispatch({ action: 'SET_APPLICANT', payload: applicant })
    }
  }, [applicant])

  useEffect(() => {
    if (isError) {
      setIsLoggedIn(false)
    }
  }, [isError, setIsLoggedIn])

  const store = useMemo(() => {
    return {
      state,
      dispatch,
    }
  }, [state])

  return <ApplicationContext.Provider value={store}>{children}</ApplicationContext.Provider>
}
